import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-start-assessment-modal',
  templateUrl: './start-assessment-modal.component.html',
  styleUrls: ['./start-assessment-modal.component.scss']
})
export class StartAssessmentModalComponent implements OnInit {

  hasExperience = true;

  constructor(
    public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  changeExperience(hasExperience) {
    this.hasExperience = hasExperience;
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

}
